define('components/polls/anchor/model', [], function () {
    function Model() {
        this.isActive = ko.observable(false);
    }

    return Model;
});